import type { IFlowButton } from '@/types/flowbutton';
import type { FlowHandler, ActionMenuItem } from './index';

export const invoiceProcessHandler: FlowHandler = {
  getMenuItems(_button: IFlowButton): ActionMenuItem[] {
    return [
      {
        icon: '🧾',
        label: 'Process Invoice',
        onClick: () => {},
        openDialog: 'invoice-process-pipeline',
      },
      {
        icon: '📋',
        label: 'View Invoices',
        onClick: () => {
          window.open('/app/psi/invoices', '_self');
        },
      },
    ];
  },
};
